// routes/AdminRoutes.jsx
import { Route } from "react-router-dom";
import PursuitAccessDashboard from "../pages/PursuitAccessPages/PursuitAccessDashboard";
import UserAssessmentsPage from "../pages/PursuitAccessPages/UserAssessmentsPage";
import ManagerCreatedAssessmentsPage from "../pages/PursuitAccessPages/ManagerCreatedAssessmentsPage";
import RecommendationsPage from "../pages/PursuitAccessPages/RecommendationsPage";
import DedicatedRequestsPage from "../pages/PursuitAccessPages/DedicatedRequestsPage";
import LearningPathDetails from "../pages/PursuitAccessPages/LearningPathDetails";
import ManagerAssessmentRecommendationsPage from "../pages/PursuitAccessPages/ManagerAssessmentRecommendationsPage";


const PursuitAccessRoutes = (
    <>
        <Route path="/pursuit/dashboard" element={<PursuitAccessDashboard />} />
        <Route path="/pursuit/self-assessments" element={<UserAssessmentsPage />} />
        <Route path="/pursuit/manager-assessments" element={<ManagerCreatedAssessmentsPage />} />
        <Route path="/recommendations/:user_id/:assessment_id" element={<RecommendationsPage />} />
        <Route path="/pursuit/dedicated-requests" element={<DedicatedRequestsPage />} />
        <Route path="/learning-path/:user_id/:assessment_id/:learningpath_id" element={<LearningPathDetails />} />
        <Route
            path="/manager/:assessment_id/recommendations"
            element={<ManagerAssessmentRecommendationsPage />}
        />
    </>
);

export default PursuitAccessRoutes;
